import React, { useEffect, useState } from 'react';
import './Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://api.escuelajs.co/api/v1/products');
        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <div className="tag">Loading products...</div>;
  }

  if (error) {
    return <div className="tag">Error: {error}</div>;
  }

  return (
    <div className='products-container'>
      {products.length > 0 ? (
        products.map((product) => (
          <div key={product.id} className='product-card'>
            <img src={product.images[0]} alt={product.title} className='product-image' />
            <h3 className='product-title'>{product.title}</h3>
            <p className='product-price'>₹{product.price}</p>
          </div>
        ))
      ) : (
        <div className='tag'>There are no products...I made this only for testing purpose...</div>
      )}
    </div>
  );
}

export default Products;
